
document.addEventListener('DOMContentLoaded', () => {
  const overlay = document.getElementById('QuickViewModal');
  const closeBtn = overlay.querySelector('.qv-close-btn');
  const contentEl = document.getElementById('QuickViewContent');

  // Open modal
  function openModal() {
    overlay.style.display = 'flex';
    requestAnimationFrame(() => overlay.classList.add('is-active'));
    document.body.style.overflow = 'hidden';
  }

  // Close modal
  function closeModal() {
    overlay.classList.remove('is-active');
    setTimeout(() => {
      overlay.style.display = 'none';
      document.body.style.overflow = '';
    }, 300);
  }

  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', (e) => { if (e.target === overlay) closeModal(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && overlay.classList.contains('is-active')) closeModal(); });

  // Format money
  function fmt(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  // Quick View buttons
  document.querySelectorAll('.fpg-quick-view-btn').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const handle = btn.getAttribute('data-handle');
      openModal();
      contentEl.innerHTML = '<div class="qv-loader"><div class="qv-spinner"></div></div>';

      try {
        const res = await fetch(`/products/${handle}.js`);
        const product = await res.json();
        const firstVariant = product.variants[0];
        const hasVariants = product.variants.length > 1;
        const hasMultipleImages = product.images && product.images.length > 1;

        // Build thumbnail strip
        let thumbsHtml = '';
        if (hasMultipleImages) {
          thumbsHtml = '<div class="qv-thumbs">' +
            product.images.map((img, i) =>
              `<img src="${img.replace(/(\.\w+)(\?|$)/, '_120x120$1$2')}" class="qv-thumb${i === 0 ? ' active' : ''}" data-full="${img}" alt="Thumbnail ${i+1}">`
            ).join('') + '</div>';
        }

        // Build variant pills
        let variantsHtml = '';
        if (hasVariants) {
          variantsHtml = '<p class="qv-variant-label">Options</p><div class="qv-variant-pills">';
          product.variants.forEach((v, i) => {
            variantsHtml += `
              <input type="radio" name="qv-variant" class="qv-variant-pill" id="qv-v-${v.id}" value="${v.id}"
                data-price="${v.price}" data-compare="${v.compare_at_price || 0}" data-available="${v.available}"
                data-img="${v.featured_image ? v.featured_image.src : ''}"
                ${i === 0 ? 'checked' : ''} ${!v.available ? 'disabled' : ''}>
              <label for="qv-v-${v.id}" class="qv-variant-pill-label">${v.title}</label>
            `;
          });
          variantsHtml += '</div>';
        }

        contentEl.innerHTML = `
          <div class="qv-gallery">
            <img class="qv-main-img" src="${product.featured_image}" alt="${product.title}" id="qvMainImage">
            ${thumbsHtml}
          </div>
          <div class="qv-info">
            <div class="qv-rating">
              <span class="qv-rating-stars">★★★★★</span>
              <span>4.9</span>
            </div>
            <h2 class="qv-title">${product.title}</h2>
            <p class="qv-type">${product.type || ''}</p>
            <div class="qv-price-row" id="qvPriceRow">
              <span class="qv-price" id="qvPrice">${fmt(firstVariant.price)}</span>
              ${firstVariant.compare_at_price && firstVariant.compare_at_price > firstVariant.price ? `
                <span class="qv-compare-price" id="qvCompare">${fmt(firstVariant.compare_at_price)}</span>
                <span class="qv-save-badge" id="qvSave">SALE</span>
              ` : '<span class="qv-compare-price" id="qvCompare" style="display:none"></span><span class="qv-save-badge" id="qvSave" style="display:none"></span>'}
            </div>
            <p class="qv-stock ${firstVariant.available ? '' : 'out-of-stock'}" id="qvStock">
              ${firstVariant.available ? '✓ In Stock' : '✗ Sold Out'}
            </p>
            ${variantsHtml}
            <div class="qv-actions">
              <div class="qv-qty">
                <button type="button" class="qv-qty-btn" id="qvQtyMinus">−</button>
                <input type="number" class="qv-qty-input" id="qvQty" value="1" min="1">
                <button type="button" class="qv-qty-btn" id="qvQtyPlus">+</button>
              </div>
              <button class="qv-atc-btn" id="qvAddToCart" data-variant-id="${firstVariant.id}" ${!firstVariant.available ? 'disabled' : ''}>
                ${firstVariant.available ? 'ADD TO CART' : 'SOLD OUT'}
              </button>
            </div>
            <p class="qv-desc">${product.description ? product.description.replace(/<[^>]+>/g, '').substring(0, 200) : ''}${product.description && product.description.length > 200 ? '...' : ''}</p>
            <div class="qv-trust">
              <span class="qv-trust-label">Secure Checkout</span>
              <svg class="qv-trust-icon" viewBox="0 0 50 32" fill="none"><rect width="50" height="32" rx="4" fill="#1A1F71"/><text x="25" y="20" text-anchor="middle" fill="#fff" font-size="11" font-weight="700" font-family="sans-serif">VISA</text></svg>
              <svg class="qv-trust-icon" viewBox="0 0 50 32" fill="none"><rect width="50" height="32" rx="4" fill="#2D2D2D"/><circle cx="20" cy="16" r="10" fill="#EB001B" opacity="0.9"/><circle cx="30" cy="16" r="10" fill="#F79E1B" opacity="0.9"/></svg>
              <svg class="qv-trust-icon" viewBox="0 0 50 32" fill="none"><rect width="50" height="32" rx="4" fill="#000"/><text x="25" y="20" text-anchor="middle" fill="#fff" font-size="9" font-weight="600" font-family="sans-serif">Pay</text></svg>
              <svg class="qv-trust-icon" viewBox="0 0 50 32" fill="none"><rect width="50" height="32" rx="4" fill="#016FD0"/><text x="25" y="18" text-anchor="middle" fill="#fff" font-size="6" font-weight="700" font-family="sans-serif">AMEX</text></svg>
            </div>
          </div>
          <a href="/products/${handle}" class="qv-full-link">View Full Details →</a>
        `;

        // --- Interactive Logic ---

        // Thumbnail click
        if (hasMultipleImages) {
          contentEl.querySelectorAll('.qv-thumb').forEach(thumb => {
            thumb.addEventListener('click', () => {
              document.getElementById('qvMainImage').src = thumb.dataset.full;
              contentEl.querySelectorAll('.qv-thumb').forEach(t => t.classList.remove('active'));
              thumb.classList.add('active');
            });
          });
        }

        // Variant change → update price, image, stock, ATC
        if (hasVariants) {
          contentEl.querySelectorAll('.qv-variant-pill').forEach(radio => {
            radio.addEventListener('change', () => {
              const price = parseInt(radio.dataset.price);
              const compare = parseInt(radio.dataset.compare);
              const available = radio.dataset.available === 'true';
              const varImg = radio.dataset.img;

              document.getElementById('qvPrice').textContent = fmt(price);

              const compareEl = document.getElementById('qvCompare');
              const saveEl = document.getElementById('qvSave');
              if (compare && compare > price) {
                compareEl.textContent = fmt(compare);
                compareEl.style.display = '';
                saveEl.style.display = '';
              } else {
                compareEl.style.display = 'none';
                saveEl.style.display = 'none';
              }

              const stockEl = document.getElementById('qvStock');
              stockEl.textContent = available ? '✓ In Stock' : '✗ Sold Out';
              stockEl.className = 'qv-stock ' + (available ? '' : 'out-of-stock');

              const atcBtn = document.getElementById('qvAddToCart');
              atcBtn.dataset.variantId = radio.value;
              atcBtn.disabled = !available;
              atcBtn.textContent = available ? 'ADD TO CART' : 'SOLD OUT';
              atcBtn.classList.remove('added');

              if (varImg) {
                document.getElementById('qvMainImage').src = varImg;
              }
            });
          });
        }

        // Quantity +/-
        const qtyInput = document.getElementById('qvQty');
        document.getElementById('qvQtyMinus').addEventListener('click', () => {
          qtyInput.value = Math.max(1, parseInt(qtyInput.value) - 1);
        });
        document.getElementById('qvQtyPlus').addEventListener('click', () => {
          qtyInput.value = parseInt(qtyInput.value) + 1;
        });

        // Add to Cart
        document.getElementById('qvAddToCart').addEventListener('click', async function() {
          const variantId = this.dataset.variantId;
          const qty = parseInt(qtyInput.value) || 1;
          this.textContent = 'ADDING...';
          this.disabled = true;

          try {
            if (window.BallistolTheme && window.BallistolTheme.cart) {
              await window.BallistolTheme.cart.addItem(variantId, qty);
            } else {
              await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: parseInt(variantId), quantity: qty })
              });
            }
            this.textContent = '✓ ADDED';
            this.classList.add('added');
            setTimeout(() => {
              this.textContent = 'ADD TO CART';
              this.disabled = false;
              this.classList.remove('added');
            }, 2000);
          } catch (err) {
            this.textContent = 'ADD TO CART';
            this.disabled = false;
          }
        });

      } catch (error) {
        contentEl.innerHTML = '<div class="qv-loader" style="color:#ff0000;font-weight:600;">Error loading product. Please try again.</div>';
      }
    });
  });
});

